module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAi0lEQVQY012OsQ3DMAwEz1ogHiEbxC2hRtkgI3iEjOJRskFUSGKrbOARnAmYRgaIEGDx+Cfvp9LaCmxAiiK9qs5ABnoUWafSWgduwBd4jPCplwAk4ANcgLczUxTZQxQ5xqWfZxTpAGEwX3+BraouAGEUOt/eHS5X1WsAumNm12kHDsyM0tpsZpzr9Q81vUJ33Wbq5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/images/delete_menuItem.png
// module id = 879
// module chunks = 0